import { AxiosError } from 'axios';

/**
 * 申込更新エラーハンドリング
 *
 * @param error キャッチしたエラー
 * @returns 日本語エラーメッセージ
 */
export const handleUpdateApplicationError = (error: unknown): string => {
    if (error instanceof AxiosError) {
        const status = error.response?.status;
        const message = error.response?.data?.message;

        switch (status) {
            case 403:
                return message || '受け渡し済みのため更新できません';
            case 404:
                return message || '申し込みデータがありません';
            case 422:
                return '入力内容を確認してください';
            default:
                return message || 'エラーが発生しました。もう一度お試しください';
        }
    }

    return '予期せぬエラーが発生しました';
};
